import { useContext, useEffect, useMemo, useState } from "react"
import { InputText } from 'primereact/inputtext';
import _ from "underscore";
import { Rating } from "@mui/material";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { useCommanKit } from "./useCommanKit";

export const useFeedback = ({ onNext, data }) => {
    const { showSuccess, showError } = useContext(ToastContext);
    const [inputValues, setInputValues] = useState({})
    const [documents, setDocuments] = useState([]);
    const { getEmployeeDetails } = useCommanKit({ data });
    const [isChanged, setIsChanged] = useState(false)

    useEffect(() => {
        const group = _.find(data?.attributeGroup, { attribute_group_key: "feedback" });
        if (group) {
            const options = _.filter(data?.attributeItems, { attribute_group_id: group.attribute_group_id })
                .map(item => ({
                    parameters: item.item_name,
                    feedback_item_id: item.attribute_item_id,
                    rating: 0,
                    suggestion: ''
                }));
            setDocuments(options);
            handleAPI(options)
        }
    }, [data?.attributeGroup, data?.attributeItems])

    const handleAPI = (options) => {
        data?.employee?.user_code && getEmployeeDetails("user_feedback_details", data?.employee?.user_code).then((res) => {
            if (res?.user_feedback_details) {
                const updatedDocs = options.map(doc => {
                    const feedback = res.user_feedback_details.find(fb => fb.feedback_item_id === doc.feedback_item_id);
                    return feedback ? { ...doc, rating: feedback.feedback_rating_value, suggestion: feedback.suggestion_remark } : doc;
                });
                setDocuments(updatedDocs);
                const data = res?.user_feedback_que_details?.[0]
                setInputValues({ like: data?.feedback_like_most, disLike: data?.feedback_notlike_most})
            }
        }).catch((error) => {
            console.error(error)
        })
    }


    const onRateChange = (rowData, newValue) => {
        setIsChanged(true)
        setDocuments(prevDocs =>
            prevDocs.map(doc =>
                doc.feedback_item_id === rowData.feedback_item_id ? { ...doc, rating: newValue } : doc
            )
        );
    };

    const onSuggestionChange = (e, rowData) => {
        setIsChanged(true)
        setDocuments(prevDocs =>
            prevDocs.map(doc =>
                doc.feedback_item_id === rowData.feedback_item_id ? { ...doc, suggestion: e.target.value } : doc
            )
        );
    };


    const srNoBodyTemplate = (rowData, options) => options.rowIndex + 1;

    const submittedBodyTemplate = (rowData) => (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Rating
                name={`rating-${rowData.feedback_item_id}`}
                value={Number(rowData.rating) || 0}
                precision={1}
                onChange={(_, newValue) => onRateChange(rowData, newValue)}
            />
        </div>
    );


    const suggestionBodyTemplate = (rowData) => (
        <InputText
            value={rowData.suggestion}
            onChange={e => onSuggestionChange(e, rowData)}
            className="input-text w100"
        />
    );


    const handleSubmit = async () => {
        try {
            if (!isChanged) {
                onNext();
                return
            }
            const feedbackDetails = documents.map(doc => ({
                feedback_item_id: doc.feedback_item_id,
                feedback_rating_value: doc.rating || 0,
                suggestion_remark: doc.suggestion || "",
            }));
            const payload = {
                tvp_feedBack_details: feedbackDetails,
                feedback_like_most: inputValues.like || "",
                feedback_notlike_most: inputValues.disLike || "",
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEEFEEDBACKDETAIL"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                onNext();
            } else {
                showError("error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error("error:", error);
        }
    };



    return useMemo(() => ({
        documents, suggestionBodyTemplate, submittedBodyTemplate, srNoBodyTemplate, inputValues, setInputValues, handleSubmit, setIsChanged
    }), [documents, suggestionBodyTemplate, submittedBodyTemplate, srNoBodyTemplate, inputValues, setInputValues, handleSubmit, setIsChanged])
}